(() => {
  const initializePolicyPage = () => {
    const container = document.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');
    const rte = body?.querySelector(':scope > .rte');

    if (!container || !body || !rte) return;
    if (container.dataset.lavPolicyInitialized === 'true') return;

    container.dataset.lavPolicyInitialized = 'true';

    const originalContent =
      rte.firstElementChild &&
      rte.children.length === 1 &&
      rte.firstElementChild.tagName === 'DIV'
        ? rte.firstElementChild
        : rte;

    const layout = document.createElement('div');
    layout.className = 'lav-policy-layout';

    const main = document.createElement('div');
    main.className = 'lav-policy-main';

    const content = document.createElement('div');
    content.className = 'lav-policy-content';

    const sidebar = document.createElement('aside');
    sidebar.className = 'lav-policy-sidebar';
    sidebar.setAttribute('aria-label', 'Policy sections');

    const nav = document.createElement('nav');
    nav.className = 'lav-policy-nav';

    const nodes = Array.from(originalContent.childNodes);

    nodes.forEach((node) => {
      content.appendChild(node);
    });

    main.appendChild(content);
    sidebar.appendChild(nav);
    layout.appendChild(main);
    layout.appendChild(sidebar);

    rte.replaceChildren(layout);

    createDateRow(content, main);
    createTableOfContents(content, nav, sidebar);
    container.classList.add('lav-policy-ready');
  };

  const createDateRow = (content, main) => {
    const firstParagraph = content.querySelector(':scope > p:first-child');

    if (!firstParagraph) {
      addDivider(main, content);
      return;
    }

    const rawText = firstParagraph.textContent.trim();
    const match = rawText.match(
      /^(last\s+(?:updated|revised)|effective\s+date)\s*:\s*(.+)$/i
    );

    if (!match) {
      addDivider(main, content);
      return;
    }

    const dateRow = document.createElement('div');
    dateRow.className = 'lav-policy-date';

    const label = document.createElement('span');
    label.className = 'lav-policy-date__label';
    label.textContent =
      match[1].toLowerCase().includes('effective')
        ? 'Effective Date'
        : 'Last Revised';

    const separator = document.createElement('span');
    separator.className = 'lav-policy-date__separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '|';

    const value = document.createElement('span');
    value.className = 'lav-policy-date__value';
    value.textContent = match[2].trim();

    dateRow.append(label, separator, value);

    firstParagraph.remove();
    main.insertBefore(dateRow, content);

    addDivider(main, content);
  };

  const addDivider = (main, content) => {
    const divider = document.createElement('hr');
    divider.className = 'lav-policy-divider';
    main.insertBefore(divider, content);
  };

  const createTableOfContents = (content, nav, sidebar) => {
    const headings = Array.from(content.querySelectorAll('h2'));

    if (!headings.length) {
      sidebar.remove();
      return;
    }

    const links = [];
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      const headingText = heading.textContent.trim();

      if (!headingText) return;

      const baseId =
        slugify(headingText.replace(/^\d+[\.\)]\s*/, '')) ||
        `policy-section-${index + 1}`;

      let uniqueId = baseId;
      let suffix = 2;

      while (
        usedIds.has(uniqueId) ||
        document.getElementById(uniqueId)
      ) {
        uniqueId = `${baseId}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;

      const item = document.createElement('div');
      item.className = 'lav-policy-nav__item';

      const link = document.createElement('a');
      link.className = 'lav-policy-nav__link';
      link.href = `#${uniqueId}`;
      link.textContent = headingText.replace(/^\d+[\.\)]\s*/, '');

      link.addEventListener('click', (event) => {
        event.preventDefault();

        heading.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'start',
        });

        window.history.replaceState(null, '', `#${uniqueId}`);
        setActiveLink(link, links);
      });

      item.appendChild(link);
      nav.appendChild(item);

      links.push({
        heading,
        link,
      });
    });

    if (!links.length) {
      sidebar.remove();
      return;
    }

    setActiveLink(links[0].link, links);

    const updateActiveSection = () => {
      const offset = 160;
      let activeIndex = 0;

      links.forEach(({ heading }, index) => {
        if (heading.getBoundingClientRect().top <= offset) {
          activeIndex = index;
        }
      });

      setActiveLink(links[activeIndex].link, links);
    };

    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        updateActiveSection();
        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, {
      passive: true,
    });

    window.addEventListener('resize', handleScroll);

    updateActiveSection();
  };

  const setActiveLink = (activeLink, links) => {
    links.forEach(({ link }) => {
      const isActive = link === activeLink;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
        link.scrollIntoView({
          block: 'nearest',
        });
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const slugify = (value) => {
    return value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePolicyPage);
  } else {
    initializePolicyPage();
  }

  document.addEventListener('shopify:section:load', initializePolicyPage);
  
})();